import axios from "axios";
import { ApiEndPoint, ApiUrl } from "../helper";
import { getStore } from "../../redux/storeRegistry";

const API = axios.create({
  baseURL: ApiUrl,
});
const requestHandler = async (request) => {
  const accessToken = localStorage.getItem("accessToken");
  try {
    request.headers["Authorization"] = "Bearer " + accessToken;
  } catch (e) {
    console.log(e, "err");
  }
  return request;
};
const refreshToken = async () => {
  try {
    const refreshTokenValue = localStorage.getItem("refreshToken");
    if (refreshTokenValue === null) {
      return;
    }
    const response = await API.post(ApiEndPoint.REFRESHTOKEN, {
      refresh_token: refreshTokenValue,
    });
    if (response.status === 200) {
      const newAccessToken = response.data?.access_token;
      const newRefreshToken = response.data?.refresh_token;
      // Update the stored tokens
      localStorage.setItem("accessToken", newAccessToken);
      localStorage.setItem("refreshToken", newRefreshToken);
      return newAccessToken;
    } else {
      // Handle error response (e.g., logout user, show login screen)
      console.error("Token refresh failed:", response.data);
      return null;
    }
  } catch (error) {
    console.error("Token refresh error:", error);
    return null;
  }
};
const responseHandler = (response) => {
  return response;
};
API.interceptors.request.use(requestHandler, (error) => {
  Promise.reject(error);
});
// Clears the stored session and sends the user back to the login screen.
// Used when the session can no longer be refreshed (e.g. the password was
// changed on another device, so this device's tokens have been revoked).
//
// We clear the auth state through Redux (RESET_APP) instead of doing
// `window.location.href = "/login"`. Setting window.location forces a full
// browser reload (re-download the bundle, re-bootstrap React/Redux), which is
// what made the redirect feel slow. Resetting Redux flips access_token to null,
// and the ProtectedRoute components react by doing an instant in-app redirect
// to /login with no page reload.
//
// The store is reached through the storeRegistry bridge (set up in index.js)
// rather than imported directly, to avoid the circular dependency
// (store -> slices -> this api module -> store).
let isLoggingOut = false;
const forceLogout = () => {
  // Guard against multiple parallel 401s all triggering a logout.
  if (isLoggingOut) {
    return;
  }
  isLoggingOut = true;
  localStorage.clear();
  const store = getStore();
  if (store) {
    store.dispatch({ type: "RESET_APP" });
  } else {
    // Safety net: if the store wasn't registered for some reason, fall back to
    // a hard redirect so the user still ends up on the login screen.
    window.location.href = "/login";
  }
};

API.interceptors.response.use(responseHandler, async (error) => {
  const orinalRequest = error.config;
  if (error.response && error.response.status === 401 && !orinalRequest.retry) {
    orinalRequest.retry = true;
    const newAccessToken = await refreshToken();
    // If the refresh failed, the session is dead: log out instead of looping.
    if (!newAccessToken) {
      forceLogout();
      return Promise.reject(error?.response);
    }
    return API(orinalRequest);
  } else if (error.response && error.response.status === 500) {
    if (error.response.status === 500) {
      console.log("internal-server-error");
    }
  }
  return Promise.reject(error?.response);
});
export default API;
